import { render, staticRenderFns } from "./MFormPrinterList.vue?vue&type=template&id=52b54e58&scoped=true"
import script from "./MFormPrinterList.vue?vue&type=script&lang=js"
export * from "./MFormPrinterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b54e58",
  null
  
)

export default component.exports